import React, { useEffect } from "react";
import TopBar from "./TopBar";
import SideBar from "./SideBar";
import MainContent from "./MainContent";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import Sidebar2 from "./SideBar2";
import { useState } from "react";
import Navbar from "./Navbar";
import { Route, Routes } from "react-router-dom";
import { CssBaseline, Typography, Box, Grid } from "@mui/material";
import AttendanceTable from "./AttendanceTable";
import AttendanceCalendar from "./AttendanceCalendar";
import DailyAttendanceReport from "./DailyAttendanceReport";
import ReportTable from "./ReportTable";
import EnhancedTable from "./EnhancedTable";
import ReportsWrapper from "./ReportsWrapper";
import ReportSelector from "./ReportSelector";
import StatusCardWrapper from "./StatusCardWrapper";
import StatsCard from "./StatusCard";
import { useUser } from "../Contexts/UserContext";
import ThreeDotLoader from "./ThreeDotLoader";
import getTodayDate from "./TodaysDate";
import EnhancedTable2 from "./EnhancedTable2";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const DOMAIN_URL = "https://www.apsgroupapp.com/ExpressAPI/facility";
const drawerWidth = 240;
const units = [
  { id: 1, name: "Unit A" },
  { id: 2, name: "Unit B" },
  { id: 3, name: "Unit C" },
];
function BranchStatus() {
  const [attData, setAttDate] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState({
    branchObj: null,
    unitObj: null,
  });
  const [fromDate, setFromDate] = useState(getTodayDate());
  const [toDate, setToDate] = useState(getTodayDate());
  const { user } = useUser();
  const columns = [
    // { id: "AttendanceDate", label: "Date" },
    { id: "UnitCode", label: "Unit Code", idx: 0 },
    { id: "UnitName", label: "Unit Name", idx: 1 },
    { id: "EmpCode", label: "EmpCode", idx: 2 },
    { id: "EmpName", label: "EmpName", idx: 3 },
    { id: "OpeningTime", label: "OpeningTime", idx: 4 },
    { id: "ClosingTime", label: "ClosingTime", idx: 5 },
  ];
  const handleFetchReports = async () => {
    setIsLoading(true);
    if (selectedData.branchObj.BranchCode == 0) {
      const res = await fetch(
        `${DOMAIN_URL}/getFacilityReport?action=getClientUnitOpenCloseData&clientCode=${user.ClientId}&unitCode=${selectedData.unitObj.UnitCode}&fromDate=2025-01-01&toDate=2025-04-01`
      ).then((res) => res.json());
      if (res.success) {
        setAttDate(res.data);
        setIsLoading(false);
      } else {
        alert("API CONNECTION ERROR :(");
        setIsLoading(false);
      }
      return;
    }
    const res = await fetch(
      `${DOMAIN_URL}/getFacilityReport?action=getClientUnitOpenCloseData&clientCode=${user.ClientId}&unitCode=${selectedData.unitObj.UnitCode}&fromDate=2025-01-01&toDate=2025-04-01`
    ).then((res) => res.json());
    if (res.success) {
      setAttDate(res.data);
      setIsLoading(false);
    } else {
      alert("API CONNECTION ERROR :(");
      setIsLoading(false);
    }
  };
  return (
    <>
      <div style={{ padding: "2rem 4rem" }}>
        <ReportSelector
          title="BRANCH OPENING AND CLOSING STATUS"
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          toDate={toDate}
          setToDate={setToDate}
          fromDate={fromDate}
          setFromDate={setFromDate}
          handleFetchReports={handleFetchReports}
        />
        {isLoading ? (
          <ThreeDotLoader />
        ) : (
          <EnhancedTable2 columns={columns} data={attData} />
        )}
      </div>
      {/* </ReportsWrapper> */}

      {/* <CssBaseline />
      <Navbar onMenuClick={toggleMenu} />
      <SideBar open={menuOpen} onClose={toggleMenu} />
      <Box component="main" sx={{ p: 3 }}>
        <Routes>
          <Route path="/" element={<h1>Url: /</h1>} />
          <Route path="/home" element={<h1>Url: /home</h1>} />
          <Route path="/about" element={<h1>Url: /about</h1>} />
          <Route path="/attendance" element={<AttendanceTable />} />
          <Route
            path="/daily-attendance-report"
            element={<DailyAttendanceReport attendanceData={attendanceData} />}
          />
        </Routes>
      </Box> */}
    </>
  );
}

export default BranchStatus;
